/* eslint-disable jsx-a11y/anchor-is-valid */

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faPhone,
  faLocationDot,
  faClock,
  faStore,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faInstagram,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";

export function LandingFooter() {
  return (
    <footer className="border-t border-gray-200 bg-white">
      <div className="mx-auto max-w-7xl px-4 py-16 lg:px-8">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* Get in Touch */}
          <div className="flex flex-col gap-4 text-left">
            <h3 className="text-2xl font-semibold text-blue-700 text-left">
              Get in Touch
            </h3>
            <div className="flex flex-col gap-3">
              <div className="flex items-start gap-3">
                <FontAwesomeIcon
                  icon={faEnvelope}
                  className="mt-0.5 h-4 w-4 shrink-0 text-blue-800"
                />
                <span className="text-lg text-gray-900 text-left">
                  mulsolgroup@gmail.com
                </span>
              </div>
              <div className="flex items-start gap-3">
                <FontAwesomeIcon
                  icon={faPhone}
                  className="mt-0.5 h-4 w-4 shrink-0 text-blue-800"
                />
                <span className="text-lg text-gray-900 text-left">
                  +255 713 343 851
                </span>
              </div>
              <div className="flex items-start gap-3">
                <FontAwesomeIcon
                  icon={faLocationDot}
                  className="mt-0.5 h-4 w-4 shrink-0 text-blue-800"
                />
                <span className="text-lg text-gray-900 text-left">
                  Darajani, Zanzibar
                </span>
              </div>
              <div className="flex items-start gap-3">
                <FontAwesomeIcon
                  icon={faClock}
                  className="mt-0.5 h-4 w-4 shrink-0 text-blue-800"
                />
                <span className="text-lg text-gray-900 text-left">
                  Mon - Sat: 8:00 AM - 6:00 PM
                </span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col gap-4 text-left">
            <h3 className="text-2xl font-semibold text-blue-700 text-left">
              Quick Links
            </h3>
            <nav
              className="flex flex-col gap-2.5"
              aria-label="Footer quick links"
            >
              <a
                href="#home"
                rel="noopener noreferrer"
                className="text-lg text-gray-900 transition-colors hover:text-blue-500 hover:font-semibold text-left"
              >
                Home
              </a>
              <a
                href="#about"
                rel="noopener noreferrer"
                className="text-lg text-gray-900 transition-colors hover:text-blue-500 hover:font-semibold text-left"
              >
                About Us
              </a>
              <a
                href="#services"
                rel="noopener noreferrer"
                className="text-lg text-gray-900 transition-colors hover:text-blue-500 hover:font-semibold text-left"
              >
                Our Services
              </a>
              <a
                href="#faq"
                rel="noopener noreferrer"
                className="text-lg text-gray-900 transition-colors hover:text-blue-500 hover:font-semibold text-left"
              >
                FAQ
              </a>
              <Link
                to="/login"
                className="text-lg text-gray-900 transition-colors hover:text-blue-500 hover:font-semibold text-left"
              >
                Login
              </Link>
            </nav>
          </div>

          {/* Our Solutions */}
          <div className="flex flex-col gap-4 text-left">
            <h3 className="text-2xl font-semibold text-blue-700 text-left">
              Our Solutions
            </h3>
            <nav
              className="flex flex-col gap-2.5"
              aria-label="Footer solutions"
            >
              <span className="text-lg text-gray-900 hover:text-blue-600 hover:font-semibold transition-colors cursor-pointer text-left">
                Sales & Purchase Tracking
              </span>
              <span className="text-lg text-gray-900 hover:text-blue-600 hover:font-semibold transition-colors cursor-pointer text-left">
                Inventory Management
              </span>
              <span className="text-lg text-gray-900 hover:text-blue-600 hover:font-semibold transition-colors cursor-pointer text-left">
                Capital & Profit Separation
              </span>
              <span className="text-lg text-gray-900 hover:text-blue-600 hover:font-semibold transition-colors cursor-pointer text-left">
                Real-Time Reports
              </span>
              <span className="text-lg text-gray-900 hover:text-blue-600 hover:font-semibold transition-colors cursor-pointer text-left">
                Staff Management
              </span>
              <span className="text-lg text-gray-900 hover:text-blue-600 hover:font-semibold transition-colors cursor-pointer text-left">
                Loss Prevention
              </span>
            </nav>
          </div>

          {/* About Shop Kiganjani */}
          <div className="flex flex-col gap-4 text-left">
            <h3 className="text-2xl font-semibold text-blue-700 text-left">
              About shop
            </h3>
            <div className="flex items-center gap-2">
              <FontAwesomeIcon
                icon={faStore}
                className="h-5 w-5 text-blue-800"
              />
              <span className="text-lg font-bold">
                <span className="text-blue-800">Shop</span>
                <span className="text-orange-600">Kiganjani</span>
              </span>
            </div>
            <p className="text-lg text-gray-900 leading-relaxed text-left">
              A modern shop management system built to empower entrepreneurs
              with the tools they need to run profitable, well-organized
              businesses.
            </p>
            <div className="flex items-center gap-3 mt-2">
              <a
                href="https://www.facebook.com/mulsolgroups"
                rel="noopener noreferrer"
                target="_blank"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-gray-100 text-gray-600 transition-colors hover:bg-blue-700 hover:text-white"
                aria-label="Facebook"
              >
                <FontAwesomeIcon icon={faFacebook} className="h-4 w-4" />
              </a>
              <a
                href="https://tz.linkedin.com/in/multichannel-solution-248309380"
                rel="noopener noreferrer"
                target="_blank"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-gray-100 text-gray-600 transition-colors hover:bg-blue-700 hover:text-white"
                aria-label="LinkedIn"
              >
                <FontAwesomeIcon icon={faLinkedin} className="h-4 w-4" />
              </a>
              <a
                href="https://www.instagram.com/mulsolgroup"
                rel="noopener noreferrer"
                target="_blank"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-gray-100 text-gray-600 transition-colors hover:bg-blue-700 hover:text-white"
                aria-label="Instagram"
              >
                <FontAwesomeIcon icon={faInstagram} className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 flex flex-col items-left justify-between gap-4 border-t border-gray-400 pt-8 sm:flex-row">
          <p className="text-xl text-gray-600 text-left">
            {"\u00A9"} 2026 Shop Kiganjani. All rights reserved. Developed by{" "}
            <a
              href="https://www.mulsolgroup.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-blue-800 hover:text-orange-600 transition-colors"
            >
              MulSol Group
            </a>
          </p>
          <div className="flex items-right gap-4">
            <a
              href="#"
              className="text-xl text-gray-600 font-medium transition-colors hover:text-blue-800 text-left"
            >
              Privacy Policy
            </a>
            <Link
              to="/terms"
              className="text-xl text-gray-600 font-medium transition-colors hover:text-blue-800 text-left"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
